'use client';

import { PageStrings } from '@alltrails/core/constants/pageStringHelpers';
import useExperiments from '@alltrails/experiments/hooks/useExperiments';
import ParkBoundary from '@alltrails/maps/components/ParkBoundary/ParkBoundary';
import ParkResults from '@alltrails/maps/components/ParkResults/ParkResults';
import useMap from '@alltrails/maps/hooks/useMap';
import { getLayerBeforeId } from '@alltrails/maps/utils/layers';
import { isTrailheadsExploreVariant } from '@alltrails/maps/utils/trailheadPinVariant';
import POIMapComponents from '@/components/POIMapComponents/POIMapComponents';
import TrailheadMapComponents from '@/components/TrailheadMapComponents/TrailheadMapComponents';
import TrailResultsMapComponents from '@/components/TrailResultsMapComponents/TrailResultsMapComponents';
import { useAppSelector } from '@/utils/redux';

export default function ExploreRootMapComponentsSlot() {
  const map = useMap();
  const { activePark } = useAppSelector(state => ({
    activePark: state.map.activePark
  }));
  const boundaryBeforeId = getLayerBeforeId(map, 'park-areas');
  const isTrailheadsExploreEnabled = isTrailheadsExploreVariant(useExperiments()?.['web-disco-rm-trailheads-explore-variants']?.value);

  return (
    <>
      {isTrailheadsExploreEnabled ? (
        <TrailheadMapComponents
          cardLocation="explore map view"
          detailedCardLocation="explore tab map view"
          mapLocation={PageStrings.EXPLORE_ALL_PAGE}
        />
      ) : (
        <TrailResultsMapComponents />
      )}
      <ParkResults />
      {activePark && boundaryBeforeId !== undefined && activePark?.ID !== undefined && (
        <ParkBoundary hoveredId={String(activePark.ID)} beforeId={boundaryBeforeId} id={activePark.ID || 0} />
      )}
      <POIMapComponents poiLocation="explore map default state" />
    </>
  );
}
